<ng-container [formGroup]="form">
    <cdk-virtual-scroll-viewport itemSize="83" minBufferPx="830" maxBufferPx="1660" [ngStyle]="styles">
        <ul class="list-group ui-sortable" formArrayName="sponsors" cdkDropList [cdkDropListData]="collection.found" (cdkDropListDropped)="dropOption($event)">
            <li class="list-group-item" *cdkVirtualFor="let sponsor of collection.found;index as i;" cdkDragLockAxis="y" cdkDrag [cdkDragData]="sponsor"
                (cdkDragStarted)="onCDKDragStarted($event)" (cdkDragEnded)="onCDKDragEnded($event)">
                <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                <div class="sponsor d-flex align-items-center" [ngClass]="{'sponsor--error': collection.found[i].invalid}">
                    <div class="sponsor__drag-and-drop d-flex align-items-center justify-content-center">
                        <app-icon-menu></app-icon-menu>
                    </div>
                    <div class="sponsor__content d-flex align-items-center">
                        <div class="sponsor__number">{{sponsor.index + 1}}.</div>
                        <img [src]="getSponsorImageUrl(sponsor)" alt="thumbnail" class="sponsor__image">
                        <div class="sponsor__container d-flex flex-column">
                            <div class="sponsor__name mb-1">{{sponsor.name}}</div>
                        </div>
                        <div class="sponsor__actions">
                            <div class="sponsor__action">
                                <app-move-to [index]="sponsor.index" (onMoveTo)="moveTo($event)"></app-move-to>
                            </div>
                          <div class="sponsor__action" (click)="editSponsor(sponsor, i)">
                            <app-icon-pen [invalid]="collection.found[i].invalid"></app-icon-pen>
                          </div>
                            <div class="sponsor__action" (click)="removeSponsor(i)">
                                <app-icon-trash [invalid]="collection.found[i].invalid"></app-icon-trash>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div class="sponsor__empty" *ngIf="collection.found.length < 1">Click <b>Add</b> to start adding your sponsors</div>
    </cdk-virtual-scroll-viewport>
</ng-container>
